import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import SummaryTile from './SummaryTile';

interface LottoPosTileProps {
    title: React.ReactNode;
    badge?: 'DEFICIT' | 'MATCHED' | 'SURPLUS';
    value: React.ReactNode;
    subtext?: React.ReactNode;
    footer?: string;
    isLoading?: boolean;
    extraContent?: React.ReactNode;
    containerSx?: SxProps<Theme>;
    cardClassName?: string;
    children?: React.ReactNode;
}

const LottoPosTile: React.FC<LottoPosTileProps> = ({
    title,
    badge,
    value,
    subtext,
    footer,
    isLoading,
    extraContent,
    containerSx,
    cardClassName,
    children
}) => {
    const isDeficit = badge === 'DEFICIT';
    const isMatched = badge === 'MATCHED';
    const isSurplus = badge === 'SURPLUS';
    const isOverallTitle = typeof title === 'string' && title === 'OVERALL';

    const tileValue = (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
            {badge && (
                <Box className={isDeficit ? 'deficit-badge' : isMatched ? 'matched-badge' : 'surplus-badge'}>
                    {badge}
                </Box>
            )}
            <Box sx={{
                color: isDeficit ? '#FF0000 !important' : (isMatched ? '#34C759 !important' : '#0000FF !important'),
                fontSize: isOverallTitle ? '20px' : '14px',
                fontWeight: isOverallTitle ? 700 : 500,
                textAlign: 'center',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                lineHeight: 1.4

            }}>
                {value}
            </Box>
        </Box>
    );

    return (
        <SummaryTile
            title={title}
            value={tileValue}
            subtext={subtext}
            footer={footer}
            isLoading={isLoading}
            extraContent={extraContent}
            containerSx={containerSx}
            cardClassName={cardClassName}
        >
            {children}
        </SummaryTile>
    );
};

export default LottoPosTile;
